import {
  type AngelouCSS,
  type BannerStyleOverrides,
  typographyStyles,
} from "@newsela/angelou";

export const trialBannerCss = (
  background: string,
): BannerStyleOverrides<AngelouCSS> => ({
  root: {
    background,
    height: "40px",

    "div:has(svg)": {
      display: "inline-flex",
      alignItems: "center",
    },
  },
});

export const trialTextCss = {
  ...typographyStyles.fontFamily.circular,

  fontSize: "16px",
  margin: 0,
  color: "white",
};
